<script setup>
    import { ref } from 'vue'

    let props = defineProps({
        handle: String,
        placeholder: String,
        list: Object
    })

    let value   = ref(null)
    let label   = ref(props.placeholder)
    let visible = ref(false)

    function toggle() {
        this.visible = !this.visible;
    }

    function select(key, option) {
        this.value = key;
        this.label = option;
    }
</script>

<template>

    <div class="custom-select" :data-value="value" :data-list="list">

        <div class="custom-select__selector relative z-10 group font-light" @click="toggle()">

            <div class="custom-select__label block bg-white py-2 border-b w-full border-cintra-grey text-cintra-grey group-hover:text-cintra-orange transition duration-300">

                <span>{{ label }}</span>

            </div>

            <div class="absolute right-0 top-1/2 -translate-y-1/2">
                <i class="fa-light fa-circle-arrow-down text-xl text-cintra-grey transition duration-300 group-hover:text-cintra-orange" :class="{ 'flip-x': visible }"></i>
            </div>

            <div :class="{ hidden : !visible, visible }">

                <ul class="list-none w-full absolute z-10 bg-white drop-shadow-lg">

                    <li class="py-2 px-4 w-full transition duration-300 text-gray-700 hover:text-white hover:bg-cintra-orange" v-if="props.placeholder && props.placeholder.length > 0" :class="{ 'custom-select__current' : props.placeholder === label }" @click="select(null, props.placeholder)">{{ props.placeholder }}</li>

                    <li class="py-2 px-4 w-full transition duration-300 text-gray-700 hover:text-white hover:bg-cintra-orange" v-for="(option, key) in props.list" :class="{ 'custom-select__current' : key === value }" @click="select(key, option)">{{ option }}</li>

                </ul>

            </div>

        </div>

        <select class="hidden" :name="handle" :id="handle">

            <option v-if="props.placeholder && props.placeholder.length > 0" value="" :selected="value === null">{{ props.placeholder }}</option>

            <option v-for="(option, key) in list" :value="key" :selected="value === key">{{ option }}</option>

        </select>

    </div>

</template>
